module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Gobi.144bbde2.jpg";